const getUniqueValuesFromStep = (step) => {
  if (step === 4) {
    return [
      "deductibleType",
      "individualDeductible",
      "familyDeductible",
      "crossAccumulate",
      "oopType",
      "individualOOPMax",
      "familyOOPMax",
    ];
  }
  if (step === 5) {
    return ["drugsCoverageType", "coinsuranceRate", "copay", "subjToDeductible"];
  }
  return [];
};

export const copyFromRowAbove = (idx, table, step, pharmacyType) => {
  const i = idx - 1;
  if (i <= 0 || !Array.isArray(table) || !table[i]) return table;

  const uniqueValues = getUniqueValuesFromStep(step);

  return table.map((row, rowIndex) => {
    if (rowIndex !== i) return row;
    const prevRow = table[i - 1];
    const newRow = { ...row };

    if (step === 5 && pharmacyType) {
      const srcTiers = prevRow.tiers || [];
      const dstTiers = newRow.tiers || [];
      const pairCount = Math.min(srcTiers.length, dstTiers.length);
      const copied = {};

      for (let index = 0; index < pairCount; index++) {
        const srcTier = srcTiers[index];
        const dstTier = dstTiers[index];

        if (prevRow[pharmacyType] && prevRow[pharmacyType][srcTier]) {
          copied[dstTier] = { ...(newRow[pharmacyType]?.[dstTier] || {}) };

          uniqueValues.forEach((key) => {
            if (prevRow[pharmacyType][srcTier][key] != null) {
              copied[dstTier][key] = prevRow[pharmacyType][srcTier][key];
            }
          });
        }
      }

      newRow[pharmacyType] = {
        ...newRow[pharmacyType],
        ...copied,
      };
    } else {
      uniqueValues.forEach((key) => {
        newRow[key] = prevRow[key];
      });
    }

    return newRow;
  });
};
